import { useState, useEffect, useCallback } from "react";
import ProductCard from "./components/ProductCard";
import SearchBar from "./components/SearchBar";
import CategoryFilter from "./components/CategoryFilter";
import "./App.css";
import TelegramBanner from "./components/TelegramBanner";

const CATEGORIES = [
  { label: "🔥 All Deals", value: "discount" },
  { label: "Electronics", value: "electronics" },
  { label: "Fashion", value: "fashion" },
  { label: "Home", value: "home" },
  { label: "Sports", value: "sports" },
  { label: "Beauty", value: "beauty" },
  { label: "Watches", value: "watches" },
  { label: "Toys", value: "toys" },
  { label: "Kitchen", value: "kitchen" },
  { label: "Jewelry", value: "jewelry" },
];

const API_BASE = "https://aliexpress-api.linktuner.com/api/aliexpress";

export default function App() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [keyword, setKeyword] = useState("discount");
  const [activeCategory, setActiveCategory] = useState("discount");
  const [searchQuery, setSearchQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const fetchProducts = useCallback(async (q) => {
    setLoading(true);
    setError(null);
    try {
      const url = `${API_BASE}/search?q=${encodeURIComponent(q)}&sort=DISCOUNT_DESC&ship_to=US&currency=USD&page_size=20`;
      const res = await fetch(url);
      const data = await res.json();
      const filtered = (data.products || []).filter(
        (p) => p.image && p.affiliate_url && parseInt(p.discount) >= 20
      );
      setProducts(filtered);
      setTotalCount(filtered.length);
    } catch (e) {
      setError("Failed to load products. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts(keyword);
  }, [keyword, fetchProducts]);

  const handleCategorySelect = (value) => {
    setActiveCategory(value);
    setKeyword(value);
    setSearchQuery("");
  };

  const handleSearch = (q) => {
    if (!q.trim()) return;
    setSearchQuery(q);
    setKeyword(q);
    setActiveCategory("");
  };

  return (
    <div className="app">
      <header className="header">
        <div className="header-inner">
          <div className="logo">
            <span className="logo-ali">Ali</span>
            <span className="logo-express">Express</span>
            <span className="logo-tag">Best Discounts</span>
          </div>
          <SearchBar onSearch={handleSearch} value={searchQuery} onChange={setSearchQuery} />
        </div>
      </header>

      <CategoryFilter
        categories={CATEGORIES}
        active={activeCategory}
        onSelect={handleCategorySelect}
      />
      <TelegramBanner />
      <main className="main">
        <div className="stats-bar">
          {loading ? (
            <span>Loading deals...</span>
          ) : error ? (
            <span className="error-text">{error}</span>
          ) : (
            <span>
              <strong>{totalCount}</strong> deals found for{" "}
              <em>"{searchQuery || activeCategory || keyword}"</em>
            </span>
          )}
        </div>

        {loading ? (
          <div className="loading-grid">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton-card" />
            ))}
          </div>
        ) : error ? (
          <div className="error-box">{error}</div>
        ) : products.length === 0 ? (
          <div className="empty-box">No deals found. Try another category.</div>
        ) : (
          <div className="grid">
            {products.map((product) => (
              <ProductCard key={product.product_id} product={product} />
            ))}
          </div>
        )}
      </main>

      <footer className="footer">
        <p>
          Best AliExpress deals updated hourly •{" "}
          <a href="https://t.me/aliexpress_best_discount" target="_blank" rel="noreferrer">
            Join our Telegram channel
          </a>
        </p>
      </footer>
    </div>
  );
}
